import { render, staticRenderFns } from "./IndependentServiceLayout.vue?vue&type=template&id=61ed14a3&scoped=true"
import script from "./IndependentServiceLayout.vue?vue&type=script&lang=js"
export * from "./IndependentServiceLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ed14a3",
  null
  
)

export default component.exports